import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Instagram, Facebook, Linkedin, Twitter,
  ArrowUp, Mail, MapPin, Phone, TreeDeciduous 
} from 'lucide-react';
import './Footer.css';
import logo from './Logo.png';
const CompactFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="ftr-cpt-root">
      
      {/* --- STAGGERED BACKGROUND ANIMATIONS --- */}
      <div className="ftr-cpt-bg-anim-top">
        <motion.svg 
          viewBox="0 0 100 100"
          animate={{ rotate: 360 }}
          transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        >
           <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="0.2" fill="none" opacity="0.1" strokeDasharray="2 4"/>
           <path d="M50 5C25.1 5 5 25.1 5 50s20.1 45 45 45 45-20.1 45-45S74.9 5 50 5z" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.05"/>
        </motion.svg>
      </div>

      <div className="ftr-cpt-bg-anim-bottom">
        <motion.svg 
          viewBox="0 0 100 100"
          animate={{ rotate: -360 }}
          transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
        >
           <path d="M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 90C27.9 90 10 72.1 10 50S27.9 10 50 10s40 17.9 40 40-17.9 40-40 40z" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.08"/>
        </motion.svg>
      </div>

      <div className="ftr-cpt-container">
        
        {/* 1. BRAND HEADER ROW */}
        <div className="ftr-cpt-header">
          <div className="ftr-cpt-brand-wrapper">
            {/* LOGO IMAGE */}
            <div className="ftr-cpt-logo-box">
               <img 
                 src={logo} 
                 alt="Sohani Logo" 
                 className="ftr-cpt-logo-img"
               />
            </div>
            <div className="ftr-cpt-brand-text">
              <h2>Sohani<span>Handicrafts</span></h2>
              <p><TreeDeciduous size={14} className="gold-icon"/> Est. 1995 • Jodhpur, Rajasthan</p>
            </div>
          </div>

          <div className="ftr-cpt-social-group">
            <span className="social-label">Follow our craft</span>
            <div className="ftr-cpt-socials">
              <a href="#" aria-label="Instagram"><Instagram size={20}/></a>
              <a href="#" aria-label="Facebook"><Facebook size={20}/></a>
              <a href="#" aria-label="Linkedin"><Linkedin size={20}/></a>
              <a href="#" aria-label="Twitter"><Twitter size={20}/></a>
            </div>
          </div>
        </div>

        {/* 2. NAVIGATION GRID */}
        <div className="ftr-cpt-grid">
          
          {/* Column: Collections */}
          <div className="ftr-cpt-col">
            <h4 className="ftr-cpt-title">Collections</h4>
            <ul className="ftr-cpt-links">
              <li><NavLink to="/products">The Marble Series</NavLink></li>
              <li><NavLink to="/products">Factory Industrial</NavLink></li>
              <li><NavLink to="/products">Reclaimed Wood</NavLink></li>
              <li><NavLink to="/products">Artisan Decor</NavLink></li>
            </ul>
          </div>

          {/* Column: The Atelier */}
          <div className="ftr-cpt-col">
            <h4 className="ftr-cpt-title">The Atelier</h4>
            <ul className="ftr-cpt-links">
              <li><NavLink to="/about" className={({isActive}) => isActive ? 'active' : ''}>Our Heritage</NavLink></li>
              <li><NavLink to="/commitments" className={({isActive}) => isActive ? 'active' : ''}>Sustainability</NavLink></li>
              <li><NavLink to="/gallery" className={({isActive}) => isActive ? 'active' : ''}>Artisan Gallery</NavLink></li>
              <li><NavLink to="/trade" className={({isActive}) => isActive ? 'active' : ''}>Trade Fairs</NavLink></li>
            </ul>
          </div>

          {/* Column: Contact (Spaced Layout) */}
          <div className="ftr-cpt-col contact-wide">
            <h4 className="ftr-cpt-title">Visit the Studio</h4>
            <div className="ftr-cpt-contact-data">
              <div className="contact-item">
                <MapPin size={18} className="gold-icon"/>
                <span>P.N. A1 Ughyog Nagar, Tanawara, Jodhpur, India</span>
              </div>
              <div className="contact-item">
                <Phone size={18} className="gold-icon"/>
                <span>+91 9251447224, 8955646892</span>
              </div>
              <div className="contact-item">
                <Mail size={18} className="gold-icon"/>
                <span>sohanihandicrafts@gmail.com</span>
              </div>
            </div>
          </div>

        </div>

        {/* 3. BOTTOM BAR */}
        <div className="ftr-cpt-bottom">
          <div className="ftr-cpt-copy">
             <p>© 2026 Sohani Handicrafts. All rights reserved.</p>
             <p className="dev-tag">Designed with ❤️ by <a href="https://dheersoftwaresolutions.com/" target="_blank" rel="noreferrer" style={{textDecoration:'none'}}>Dheer Software Solutions</a></p>
          </div>

          <button className="ftr-cpt-scroll-top" onClick={scrollToTop}>
            <span>Back to top</span>
            <div className="arrow-box"><ArrowUp size={16}/></div>
          </button>
        </div>

      </div>
    </footer>
  );
};

export default CompactFooter;